import { SxProps, Theme } from '@mui/material'

export const formStyles = {
  emptyPickupTimes: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 1,
    py: 2
  } as SxProps<Theme>,

  emptyPickupTimesIcon: { color: 'grey.400' } as SxProps<Theme>,

  emptyPickupTimesText: { fontSize: '0.875rem' } as SxProps<Theme>,

  cutOffCell: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 0.5
  } as SxProps<Theme>,

  cutOffCaption: { fontSize: '0.75rem' } as SxProps<Theme>,

  tabs: {
    minHeight: 0,
    '& .MuiTab-root': {
      minHeight: 0,
      bgcolor: 'grey.100',
      borderTopLeftRadius: 4,
      borderTopRightRadius: 4
    },
    '& .MuiTab-root.Mui-selected': {
      bgcolor: 'transparent'
    }
  } as SxProps<Theme>,

  dayCard: {
    mb: 2,
    borderRadius: 1,
    overflow: 'hidden',
    border: '1px solid',
    borderColor: 'divider'
  } as SxProps<Theme>,

  dayCardHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    bgcolor: 'grey.300',
    px: 2,
    py: 0.5,
    cursor: 'pointer'
  } as SxProps<Theme>,

  dayCardHeaderLeft: { display: 'flex', alignItems: 'center' } as SxProps<Theme>,

  dayCheckbox: { minWidth: 160, ml: 0.5 } as SxProps<Theme>,

  dayCardBody: { pb: 2 } as SxProps<Theme>,

  exceptionCard: {
    mb: 2,
    borderRadius: 1,
    border: '1px solid',
    borderColor: 'divider',
    p: 2
  } as SxProps<Theme>,

  exceptionHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  } as SxProps<Theme>,

  exceptionHeaderLeft: { display: 'flex', alignItems: 'center', gap: 1 } as SxProps<Theme>,

  exceptionSchedulesWrapper: { mt: 1 } as SxProps<Theme>,

  exceptionSchedulesTitle: { fontWeight: 500, mb: 1 } as SxProps<Theme>
}
